import { render, staticRenderFns } from "./Macheo.vue?vue&type=template&id=aa286738"
import script from "./Macheo.vue?vue&type=script&lang=js"
export * from "./Macheo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports